'use client';

import { css } from 'styled-components';
import { theme } from '@frameio/vapor-theme';

export const baseTextStyles = {
  fontFamily: theme.fonts.body,
  lineHeight: 'var(--line-height)',
  margin: 0,
  WebkitTextSizeAdjust: 'none',
} as const;

export const textVariants = {
  titleLarge: {
    fontFamily: 'heading',
    fontWeight: theme.fontWeights.semiBold,
    fontSize: '48px',
    lineHeight: '56px',
    letterSpacing: '-0.0075em',
  },
  titleMedium: {
    fontFamily: 'heading',
    fontWeight: theme.fontWeights.semiBold,
    fontSize: '40px',
    lineHeight: '48px',
    letterSpacing: '-0.0075em',
  },
  titleSmall: {
    fontFamily: 'heading',
    fontWeight: theme.fontWeights.semiBold,
    fontSize: '24px',
    lineHeight: '28px',
  },
  subtitleLarge: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.regular,
    fontSize: '21px',
    lineHeight: '28px',
  },
  subtitleMedium: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.regular,
    fontSize: '18px',
    lineHeight: '28px',
  },
  subtitleSmall: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.regular,
    fontSize: '13px',
    lineHeight: '20px',
  },
  header: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.medium,
    fontSize: '16px',
    lineHeight: '20px',
  },
  primary: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.regular,
    fontSize: '14px',
    lineHeight: '20px',
  },
  secondary: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.regular,
    fontSize: '12px',
    lineHeight: '16px',
  },
  body: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.regular,
    fontSize: '13px',
    lineHeight: '20px',
  },
  link: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.medium,
    fontSize: '13px',
    lineHeight: '20px',
  },
  linkSmall: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.medium,
    fontSize: '12px',
    lineHeight: '20px',
  },
  caption: {
    fontFamily: 'body',
    fontWeight: theme.fontWeights.medium,
    fontSize: '11px',
    lineHeight: '16px',
  },
} as const;

export const textStyles = Object.fromEntries(
  Object.entries(textVariants).map(
    ([key, { lineHeight, fontFamily, ...variantTextStyles }]) => [
      key,
      css({
        margin: 0,
        WebkitTextSizeAdjust: 'none',
        '--line-height': lineHeight,
        lineHeight: `var(--line-height)`,
        fontFamily: theme.fonts[fontFamily],
        ...variantTextStyles,
      }),
    ]
  )
) as { [K in keyof typeof textVariants]: ReturnType<typeof css> };
